/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Auth0RoleResponseDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { OrganizationDeletionReportDTO } from '../models';
// @ts-ignore
import type { OrganizationProvisionCreateDTO } from '../models';
// @ts-ignore
import type { OrganizationProvisionResponseDTO } from '../models';
// @ts-ignore
import type { OrganizationResponseDTO } from '../models';
/**
 * AdminOrganizationsApi - axios parameter creator
 * @export
 */
export const AdminOrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuth0RolesApiV1AdminOrganizationsRolesGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/organizations/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuth0RolesApiV1AdminOrganizationsRolesGet_3: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/organizations/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionOrganizationApiV1AdminOrganizationsPost: async (organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationProvisionCreateDTO' is not null or undefined
            assertParamExists('provisionOrganizationApiV1AdminOrganizationsPost', 'organizationProvisionCreateDTO', organizationProvisionCreateDTO)
            const localVarPath = `/api/v1/admin/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationProvisionCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionOrganizationApiV1AdminOrganizationsPost_4: async (organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationProvisionCreateDTO' is not null or undefined
            assertParamExists('provisionOrganizationApiV1AdminOrganizationsPost_4', 'organizationProvisionCreateDTO', organizationProvisionCreateDTO)
            const localVarPath = `/api/v1/admin/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationProvisionCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationsApi - functional programming interface
 * @export
 */
export const AdminOrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDeletionReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDeletionReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auth0RoleResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.listAuth0RolesApiV1AdminOrganizationsRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auth0RoleResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.listAuth0RolesApiV1AdminOrganizationsRolesGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProvisionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.provisionOrganizationApiV1AdminOrganizationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProvisionResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationsApi.provisionOrganizationApiV1AdminOrganizationsPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationsApi - factory interface
 * @export
 */
export const AdminOrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationsApiFp(configuration)
    return {
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationDeletionReportDTO> {
            return localVarFp.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
         * @summary Delete Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationDeletionReportDTO> {
            return localVarFp.deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponseDTO> {
            return localVarFp.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Load a single organization for the current organization admin.
         * @summary Get Admin Organization
         * @param {string} organizationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponseDTO> {
            return localVarFp.getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Auth0RoleResponseDTO>> {
            return localVarFp.listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List Auth0 roles available for organization provisioning.
         * @summary List Auth0 Roles
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Auth0RoleResponseDTO>> {
            return localVarFp.listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationProvisionResponseDTO> {
            return localVarFp.provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a tenant and its initial owner user.
         * @summary Provision Organization
         * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationProvisionResponseDTO> {
            return localVarFp.provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationsApi - object-oriented interface
 * @export
 * @class AdminOrganizationsApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationsApi extends BaseAPI {
    /**
     * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
     * @summary Delete Organization
     * @param {string} organizationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hard-delete an organization and all its data (GDPR right-to-erasure). Platform-admin only.
     * @summary Delete Organization
     * @param {string} organizationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).deleteOrganizationApiV1AdminOrganizationsOrganizationIdDelete_1(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Load a single organization for the current organization admin.
     * @summary Get Admin Organization
     * @param {string} organizationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Load a single organization for the current organization admin.
     * @summary Get Admin Organization
     * @param {string} organizationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).getAdminOrganizationApiV1AdminOrganizationsOrganizationIdGet_2(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Auth0 roles available for organization provisioning.
     * @summary List Auth0 Roles
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).listAuth0RolesApiV1AdminOrganizationsRolesGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Auth0 roles available for organization provisioning.
     * @summary List Auth0 Roles
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).listAuth0RolesApiV1AdminOrganizationsRolesGet_3(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a tenant and its initial owner user.
     * @summary Provision Organization
     * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).provisionOrganizationApiV1AdminOrganizationsPost(organizationProvisionCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a tenant and its initial owner user.
     * @summary Provision Organization
     * @param {OrganizationProvisionCreateDTO} organizationProvisionCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationsApi
     */
    public provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO: OrganizationProvisionCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminOrganizationsApiFp(this.configuration).provisionOrganizationApiV1AdminOrganizationsPost_4(organizationProvisionCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

